<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import AdminAnnouncements from './Admin/AdminAnnouncements.vue'
</script>

<template>
    <StackLayout direction="column" :gap="16">
        <AdminAnnouncements />
    </StackLayout>
</template>
